<template>
  <card type="user">
    <p class="card-text"></p>
    <div class="author">
      <div class="block block-one"></div>
      <div class="block block-two"></div>
      <div class="block block-three"></div>
      <div class="block block-four"></div>
      <a href="#">
        <img class="avatar" src="img/default.png" alt="...">
        <h5 class="title">{{profile.employee.first_name + ' ' + profile.employee.last_name}}</h5>
      </a>
      <p class="description">{{profile.user.description}}</p>
      <p class="description">Date of creation: <i>{{getDate(profile.employee.date)}}</i></p>
      <p class="description">Payroll: <i>{{profile.employee.rate}}$ per hour</i></p>
    </div>
    <p></p>
    <p class="card-description">{{profile.employee.description}}</p>
    <div slot="footer" class="button-container"></div>
  </card>
</template>
<script>
  export default {
    props: ['profile'],
    name: 'user-card',
    data(){
      return{
        avatar:'',
      }
    },
    methods:{
      getDate(date){
        const locDate = new Date(date.split('-').join('/'));
        return locDate.toLocaleDateString();
      },
    },
    mounted() {

    }
  }
</script>
<style>
</style>
